import { render, staticRenderFns } from "./ArticleModalViewer.vue?vue&type=template&id=3dde51be&scoped=true&"
import script from "./ArticleModalViewer.vue?vue&type=script&lang=js&"
export * from "./ArticleModalViewer.vue?vue&type=script&lang=js&"
import style0 from "./ArticleModalViewer.vue?vue&type=style&index=0&id=3dde51be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dde51be",
  null
  
)

export default component.exports